"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDataValue = void 0;
var defaultValue_1 = require("./defaultValue");
var checkType_1 = require("./checkType");
var mround_1 = require("../methods/mround");
var capitalize_1 = require("../methods/capitalize");
var fdatetime_1 = require("../methods/fdatetime");
var check_1 = require("../methods/check");
/**
 * ustawienie danych zgodnie ze schematem
 *
 * @export
 * @param {JSONSchema} schema schemat
 * @param {*} data obiekt reprezentujący dane docelowe
 * @param {*} value dane do zapisu
 * @param {(string | string[])} [path] ścieżka
 * @param {number} [pathIndex=0] indeks na ścieżce (dane wewnętrzne)
 * @param {*} [Vue] konktruktor Vue
 * @param {boolean} [fixArraySize] czy ustawiać nowy rozmiar tablicyw  przypadku tablic
 * @returns {boolean} czy udało się ustawić
 */
function setData(schema, data, value, path, pathIndex, Vue, fixArraySize) {
    if (pathIndex === void 0) { pathIndex = 0; }
    if (path !== undefined) {
        if (typeof path === 'string') {
            path = path
                .replace(/\[/g, '.')
                .replace(/\]/g, '')
                .split('.')
                .filter(function (x) { return x; });
            pathIndex = 0;
        }
        var cpath = path[pathIndex];
        if (cpath) {
            if (schema.type === 'object') {
                var dschema = schema.properties[cpath];
                if (dschema !== undefined) {
                    if (dschema.type === 'object' || dschema.type === 'array') {
                        var data2 = data[cpath];
                        if (data2 === undefined) {
                            data2 = (0, defaultValue_1.default)(dschema, true);
                            if (Vue) {
                                Vue.set(data, cpath, data2);
                            }
                            else {
                                data[cpath] = data2;
                            }
                        }
                        return setData(dschema, data2, value, path, pathIndex + 1, Vue, fixArraySize);
                    }
                    else {
                        return setDataValue(dschema, data, cpath, value, Vue);
                    }
                }
                else {
                    return false;
                }
            }
            else if (schema.type === 'array') {
                var dschema = schema.items;
                if (dschema !== undefined) {
                    var index = parseInt(cpath, 10);
                    var data2 = data[index];
                    if (data2 === undefined) {
                        while (data.length < index + 1) {
                            data.push((0, defaultValue_1.default)(dschema, true));
                        }
                        // data2 = data[index];
                    }
                    if (dschema.type === 'array' || dschema.type === 'object') {
                        return setData(dschema, data[index], value, path, pathIndex + 1, Vue, fixArraySize);
                    }
                    else {
                        return setDataValue(dschema, data, index, value, Vue);
                    }
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    }
    if (schema.type === 'object') {
        return setDataObj(schema, data, value, Vue, fixArraySize);
    }
    else {
        return setDataArray(schema, data, value, Vue, fixArraySize);
    }
}
exports.default = setData;
/**
 * ustawia proste dane
 *
 * @export
 * @param {JSONSchema} schema schemat
 * @param {*} parent obiekt docelowy
 * @param {*} key klucz
 * @param {*} value nowa wartość
 * @param {*} [Vue] konsktruktor Vue
 * @returns {boolean} czy udało się ustawić
 */
function setDataValue(schema, parent, key, value, Vue) {
    // fix type
    if (value != null) {
        switch (schema.type) {
            case "number":
            case "money":
            case "integer":
                if (typeof value === "string") {
                    value = +value.replace(',', '.');
                    if (isNaN(value)) {
                        return false;
                    }
                }
                if (typeof value === "number") {
                    if (schema.precision && typeof schema.precision === "number") {
                        value = (0, mround_1.default)(value, schema.precision);
                    }
                    else {
                        switch (schema.type) {
                            case "integer":
                                value = (0, mround_1.default)(value, 0);
                                break;
                            case "money":
                                value = (0, mround_1.default)(value, 2);
                                break;
                            case "number":
                                value = (0, mround_1.default)(value, 8);
                                break;
                        }
                    }
                }
                break;
            case "boolean":
                if (typeof value === "string") {
                    value = value !== 'false' && value !== 'off' && value !== '';
                }
                else if (typeof value === "number") {
                    value = value != 0;
                }
                break;
            case "string":
                if (typeof value === "number") {
                    value = "" + value;
                }
                else if (typeof value === "boolean") {
                    value = value ? "true" : "false";
                }
                else if (typeof value === "object") {
                    if (value instanceof Date) {
                        value = (0, fdatetime_1.default)(value);
                    }
                    else {
                        var svalue = '' + value;
                        if (svalue === '[object Object]') {
                            svalue = JSON.stringify(value);
                        }
                        value = svalue;
                    }
                }
                if (typeof value === "string") {
                    switch (schema.format) {
                        case "uppercase":
                            value = value.toLocaleUpperCase();
                            break;
                        case "lowercase":
                            value = value.toLocaleLowerCase();
                            break;
                        case "capitalize":
                            value = (0, capitalize_1.default)(value);
                            break;
                        case "date":
                            if (value && value.length > 10) {
                                value = value.substr(0, 10);
                            }
                            ;
                            if (!(0, check_1.default)('date', value)) {
                                value = '';
                            }
                            break;
                        case "date-time":
                            if (value.indexOf('Z') > -1) {
                                var dt = new Date(value);
                                if (!isNaN(dt.getTime())) {
                                    value = (0, fdatetime_1.default)(new Date(value));
                                }
                                else {
                                    value = '';
                                }
                            }
                            else if (value.indexOf('T') === 10) {
                                value = value.replace('T', ' ');
                            }
                            if (value.length < 19) {
                                if (value.length >= 10) {
                                    value = value.substr(0, 10) + ' 00:00:00';
                                }
                            }
                            ;
                            if (!(0, check_1.default)('date-time', value)) {
                                value = '';
                            }
                            break;
                    }
                }
        }
    }
    if ((0, checkType_1.default)(schema, value)) {
        if (Vue) {
            Vue.set(parent, key, value);
            parent[key] = value;
        }
        else {
            parent[key] = value;
        }
        return true;
    }
    return false;
}
exports.setDataValue = setDataValue;
/**
 * ustawia dane tablicowe
 *
 * @param {JSONSchema} schema schemat
 * @param {any[]} destArray docelowa tablica
 * @param {any[]} value nowa wartość
 * @param {*} [Vue] konsktruktor Vue
 * @param {boolean} [fixArraySize] czy ustawić nowy rozmiar tablicy
 * @returns {boolean} czy udało się ustawić
 */
function setDataArray(schema, destArray, value, Vue, fixArraySize) {
    if (value === undefined)
        return false;
    var sitems = schema.items;
    if (fixArraySize) {
        while (destArray.length > value.length) {
            destArray.splice(destArray.length - 1, 1);
        }
    }
    for (var i = 0; i < value.length; i++) {
        var nitem = destArray[i];
        if (nitem === undefined) {
            nitem = (0, defaultValue_1.default)(sitems, true);
            if (i > destArray.length - 1) {
                destArray.push(nitem);
            }
            else {
                if (Vue) {
                    Vue.set(destArray, i, nitem);
                }
                else {
                    destArray[i] = nitem;
                }
            }
        }
        switch (sitems.type) {
            case 'object':
                setDataObj(sitems, nitem, value[i], Vue, fixArraySize);
                break;
            case 'array':
                setDataArray(sitems, nitem, value[i], Vue, fixArraySize);
                break;
            default:
                if (i > destArray.length - 1) {
                    destArray.push(value[i]);
                }
                else {
                    if (Vue) {
                        Vue.set(destArray, i, value[i]);
                    }
                    else {
                        destArray[i] = value[i];
                    }
                }
                break;
        }
    }
    return true;
}
/**
 * ustawia dane obiektowe
 *
 * @param {JSONSchema} schema schemat
 * @param {*} parentObject docelowy obiekt
 * @param {*} value nowa wartość
 * @param {*} [Vue] konsktruktor Vue
 * @param {boolean} [fixArraySize] czy ustawić nowy rozmiar tablicy
 * @returns {boolean}czy udało się ustawić
 */
function setDataObj(schema, parentObject, value, Vue, fixArraySize) {
    var props = schema.properties;
    if (!props) {
        return false;
    }
    for (var key in value) {
        if (value.hasOwnProperty(key)) {
            var pschema = props[key];
            if (pschema !== undefined) {
                var kvalue = value[key];
                switch (pschema.type) {
                    case 'object':
                        if (kvalue === null) {
                            setDataValue(pschema, parentObject, key, null, Vue);
                            continue;
                        }
                        var nparent = parentObject[key];
                        if (nparent === undefined || nparent === null) {
                            setDataValue(pschema, parentObject, key, (0, defaultValue_1.default)(pschema) || {}, Vue);
                            nparent = parentObject[key];
                        }
                        setDataObj(pschema, nparent, kvalue, Vue, fixArraySize);
                        break;
                    case 'array':
                        if (kvalue === null) {
                            setDataValue(pschema, parentObject, key, null, Vue);
                            continue;
                        }
                        var narray = parentObject[key];
                        if (narray === undefined || narray === null) {
                            parentObject[key] = narray = (0, defaultValue_1.default)(pschema);
                        }
                        setDataArray(pschema, narray, kvalue, Vue, fixArraySize);
                        break;
                    default:
                        setDataValue(pschema, parentObject, key, kvalue, Vue);
                        break;
                }
            }
        }
    }
    return true;
}
/*
function setDataKey(schema: JSONSchema, parent: any, key: any, value: any): boolean {
  if (schema.type === 'object') {
    if (typeof value === 'object') {
      let destobj = parent[key];
      if (destobj === undefined) {
        parent[key] = destobj = defaultValue(schema, true);
      }
      const keys = Object.keys(value);
      const props = schema.properties as any;
      const dkeys = Object.keys(props);
      for (const skey of keys) {
        const dschema = props[skey];
        if (dschema !== undefined) {
          setData(dschema, destobj, skey, value[skey]);
        }
      }
      return true;
    } else {
      return false;
    }
  } else if (schema.type === 'array') {
    if (Array.isArray(value)) {
      let destobj = parent[key];
      if (destobj === undefined) {
        parent[key] = destobj = defaultValue(schema, true);
      }
      const items = schema.items as JSONSchema;
      for (let i = 0; i < value.length; i++) {
        setData(items, destobj, i, value[i]);
      }
      return true;
    } else {
      return false;
    }
  } else {
    switch (schema.type) {
      case 'integer':
      case 'number':
      case 'money':
        if (typeof value === 'number') {
          parent[key] = value;
          return true;
        } else {
          return false;
        }
      case 'string':
        if (typeof value === 'string') {
          parent[key] = value;
          return true;
        } else {
          return false;
        }
      case 'boolean':
        if (typeof value === 'boolean') {
          parent[key] = value;
          return true;
        } else {
          return false;
        }
      default:
        return false;
    }
  }
}
*/
//# sourceMappingURL=setData.js.map